// Static data loader utility
let allPagesData = null;
let homePageData = null;

// Synchronous static data loader for immediate initialization
export const loadStaticDataSync = (pageName) => {
  try {
    // Use require for synchronous loading during component initialization
    const allData = require('../static/allPagesData.json');
    return allData[pageName] || null;
  } catch (error) {
    console.warn(`Static data not available for synchronous loading: ${error.message}`);
    return null;
  }
};

// Synchronous home page data loader
export const loadHomePageDataSync = () => {
  try {
    const homeData = require('../static/homePageData.json');
    return homeData.homePage || null;
  } catch (error) {
    console.warn(`Home page static data not available: ${error.message}`);
    return null;
  }
};

// Async static data loader (existing functionality)
export const loadStaticData = async (dataFile) => {
  try {
    // Try to load static data first
    const staticDataModule = await import(`../static/${dataFile}.json`);
    return staticDataModule.default;
  } catch (error) {
    console.warn(`Static data file ${dataFile}.json not found, will use runtime fetching`);
    return null;
  }
};

export const getAllPagesData = async () => {
  if (!allPagesData) {
    allPagesData = await loadStaticData('allPagesData');
  }
  return allPagesData;
};

export const getStaticHomePageData = async () => {
  if (!homePageData) {
    homePageData = await loadStaticData('homePageData');
  }
  return homePageData;
};

export const getStaticPageData = async (pageName) => {
  const allData = await getAllPagesData();
  return allData ? allData[pageName] : null;
};

// Helper function to get initial page data with fallback
export const getInitialPageData = (pageName, defaultContent) => {
  const staticData = loadStaticDataSync(pageName);
  return staticData || defaultContent;
};

// Helper function to get initial home page data with fallback
export const getInitialHomePageData = (defaultContent) => {
  const staticData = loadHomePageDataSync();
  return staticData || defaultContent;
};
